__turbopack_context__.v({
  "empty": "ServiceStatusLookup-module-scss-module__aI37Ra__empty",
  "error": "ServiceStatusLookup-module-scss-module__aI37Ra__error",
  "form": "ServiceStatusLookup-module-scss-module__aI37Ra__form",
  "formActions": "ServiceStatusLookup-module-scss-module__aI37Ra__formActions",
  "formBlock": "ServiceStatusLookup-module-scss-module__aI37Ra__formBlock",
  "header": "ServiceStatusLookup-module-scss-module__aI37Ra__header",
  "intro": "ServiceStatusLookup-module-scss-module__aI37Ra__intro",
  "loaderPlaceholder": "ServiceStatusLookup-module-scss-module__aI37Ra__loaderPlaceholder",
  "root": "ServiceStatusLookup-module-scss-module__aI37Ra__root",
  "search": "ServiceStatusLookup-module-scss-module__aI37Ra__search",
  "searchButton": "ServiceStatusLookup-module-scss-module__aI37Ra__searchButton",
  "title": "ServiceStatusLookup-module-scss-module__aI37Ra__title",
});
